























import {Component, Prop, Vue,Watch} from 'vue-property-decorator';
import ISearch from '@/components/icons/ISearch.vue';

@Component({
  name: "search",
  components: {
    'i-search': ISearch,
  }
})
export default class Search extends Vue {
  @Prop({type: [String], default: 'Поиск'}) protected placeholder!: string
  @Prop({type: [String], default: '220px'}) protected width!: string
  @Prop({type: [String], default: '36px'}) protected height!: string
  @Prop({type: String, default: ''}) value !:any
  @Prop({type: Boolean, default: false}) disable !:any
  @Prop({type: Boolean, default: false}) isFilter !:any

  @Watch('disable', {immediate: true, deep: true})
  setFocus(val:boolean){
    if(!val){
      this.$nextTick(() => {
        const editButtonRef = this.$refs.search as HTMLInputElement;
        editButtonRef.focus();
      });
    }
  }

  click() {
    this.$emit('clickSearch')
  }

}
